module.exports = __webpack_public_path__ + "static/img/iStock-148082014.15c9e4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iStock-148082014.png
// module id = 1715
// module chunks = 5